<template>
  <div class="container login-box">
    <div class="row">
        <div class="col-10 offset-1 col-md-6 offset-md-3 section">
            <h1>Please Login</h1>
            <form @submit.prevent="login" method="POST" action="/login" class="form">
              <input  v-model="redirect" type="hidden" class="form-control"/>
              <div class="form-group">
                <input v-model="username" name="username" placeholder="Username" class="form-control"/>
              </div>
              <div class="form-group">
                <input v-model="password" name="password" type="password" placeholder="Password" class="form-control"/>
              </div>
              <div class="form-group">
                <button class="btn btn-primary">Submit</button>
              </div>
            </form>

      </div>
  </div>
  <div class="row">
      <div class="col-10 offset-1 col-md-6 offset-md-3 section-blank">
            <router-link to="/reset-password">Forgot Password</router-link>
        </div>
    </div>
  </div>
</template>

<script type="text/babel">
  const LOGIN_URL = 'login';

  export default {

    data() {
      return {
        username: '',
        password: '',
        redirect: ''
      }
    },

    beforeCreate(){
      console.log(this.$store.getters.checkAuth);
      /*if(this.$store.getters.checkAuth){
        var redirect = this.redirect || '/account-details';
        this.$router.push(redirect);
      }*/
    },

    methods:{
      login(){
        var _this = this;
        this.$store.commit('setStatus', {
          status: null,
          message:null
        });

        this.$send(this, 'userLogin',{
          username: this.username,
          password: this.password
        }).then(r => {



          this.$store.commit('authenticate', {
            is_authenticated: true,
            auth_token: r.token
          });


          var redirect = _this.redirect || '/account-details';
          this.$router.push(redirect);

        });

      }
    }
  }

</script>
<style>
h1{
  font-size: 16px;
}

  .login-box{
    margin-top: 150px;
  }

</style>



// WEBPACK FOOTER //
// Login.vue?69f46010